const forOwn = require('mout/object/forOwn')

export default function checkIfItemCompleted(itemId, activities) {
  let isItemCompleted = false
  forOwn(activities, (activity) => {
    if (activity.itemId === itemId) {
      if (activity.verb === 'answered') {
        isItemCompleted = true
      }
    }
  })
  return isItemCompleted
}


// WEBPACK FOOTER //
// ./src/helpers/checkIfItemCompleted.js